/* eslint-disable */
// AUTO-GENERATED FILE. DO NOT EDIT.
// Generated by scripts/generate-route-meta.mjs

export const routeMeta = {
  "GET/api/users/collection/products": {
    "method": "GET",
    "path": "/api/users/collection/products",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "PUT/api/users/collection/products": {
    "method": "PUT",
    "path": "/api/users/collection/products",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/users/collection/products": {
    "method": "POST",
    "path": "/api/users/collection/products",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "DELETE/api/users/collection/products": {
    "method": "DELETE",
    "path": "/api/users/collection/products",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/character-assets": {
    "method": "GET",
    "path": "/api/character-assets",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "PUT/api/character-assets": {
    "method": "PUT",
    "path": "/api/character-assets",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/character-assets": {
    "method": "POST",
    "path": "/api/character-assets",
    "bodyKind": "multipart",
    "contentType": "multipart/form-data",
    "binaryFields": [
      "mainImage",
      "otherImages"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "DELETE/api/character-assets": {
    "method": "DELETE",
    "path": "/api/character-assets",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "PUT/api/admin/video-creation-option": {
    "method": "PUT",
    "path": "/api/admin/video-creation-option",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "PUT/api/admin/suppliers-priority": {
    "method": "PUT",
    "path": "/api/admin/suppliers-priority",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/video/script-generate": {
    "method": "GET",
    "path": "/api/video/script-generate",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/video/script-generate": {
    "method": "POST",
    "path": "/api/video/script-generate",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/video/script-analysis": {
    "method": "GET",
    "path": "/api/video/script-analysis",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/video/script-analysis": {
    "method": "POST",
    "path": "/api/video/script-analysis",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/remake": {
    "method": "POST",
    "path": "/api/video/remake",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/remake/credit-preview": {
    "method": "POST",
    "path": "/api/video/remake/credit-preview",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/reference-script": {
    "method": "POST",
    "path": "/api/video/reference-script",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/recreation": {
    "method": "POST",
    "path": "/api/video/recreation",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/link-preview": {
    "method": "POST",
    "path": "/api/video/link-preview",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/creation": {
    "method": "POST",
    "path": "/api/video/creation",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/creation/credit-preview": {
    "method": "POST",
    "path": "/api/video/creation/credit-preview",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/users/trash": {
    "method": "GET",
    "path": "/api/users/trash",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/trash": {
    "method": "POST",
    "path": "/api/users/trash",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "DELETE/api/users/trash": {
    "method": "DELETE",
    "path": "/api/users/trash",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/trash/restore": {
    "method": "POST",
    "path": "/api/users/trash/restore",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/publish/submit": {
    "method": "POST",
    "path": "/api/users/publish/submit",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/publish/confirm": {
    "method": "POST",
    "path": "/api/users/publish/confirm",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/publish/cancel": {
    "method": "POST",
    "path": "/api/users/publish/cancel",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/users/profile": {
    "method": "GET",
    "path": "/api/users/profile",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/users/profile": {
    "method": "POST",
    "path": "/api/users/profile",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/open-api-key/device-flow/confirm": {
    "method": "POST",
    "path": "/api/users/open-api-key/device-flow/confirm",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/users/modify-avatar": {
    "method": "POST",
    "path": "/api/users/modify-avatar",
    "bodyKind": "binary-json",
    "contentType": "application/json",
    "binaryFields": [
      "file"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/users/media-agreement": {
    "method": "GET",
    "path": "/api/users/media-agreement",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/media-agreement": {
    "method": "POST",
    "path": "/api/users/media-agreement",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/link/unbind": {
    "method": "POST",
    "path": "/api/users/link/unbind",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/users/collection/status": {
    "method": "POST",
    "path": "/api/users/collection/status",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/users/collection/save": {
    "method": "POST",
    "path": "/api/users/collection/save",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/collection/queryList": {
    "method": "POST",
    "path": "/api/users/collection/queryList",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/users/ai-jobs/resubmit": {
    "method": "POST",
    "path": "/api/users/ai-jobs/resubmit",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/user-assets/upload-video": {
    "method": "POST",
    "path": "/api/user-assets/upload-video",
    "bodyKind": "multipart",
    "contentType": "multipart/form-data",
    "binaryFields": [
      "video"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/upload-images-by-url": {
    "method": "POST",
    "path": "/api/video/upload-images-by-url",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/user-assets/upload-images-by-url": {
    "method": "POST",
    "path": "/api/user-assets/upload-images-by-url",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/video/upload-images": {
    "method": "POST",
    "path": "/api/video/upload-images",
    "bodyKind": "binary-json",
    "contentType": "application/json",
    "binaryFields": [
      "images"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/user-assets/upload-images": {
    "method": "POST",
    "path": "/api/user-assets/upload-images",
    "bodyKind": "binary-json",
    "contentType": "application/json",
    "binaryFields": [
      "images"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/translation/translate": {
    "method": "POST",
    "path": "/api/translation/translate",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/token/refresh": {
    "method": "POST",
    "path": "/api/token/refresh",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/report/submit": {
    "method": "POST",
    "path": "/api/report/submit",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/product/parse-info-by-link": {
    "method": "POST",
    "path": "/api/product/parse-info-by-link",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/product/parse-info-by-id": {
    "method": "POST",
    "path": "/api/product/parse-info-by-id",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/product/infer-selling-point": {
    "method": "POST",
    "path": "/api/product/infer-selling-point",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/product/image-check-and-describe": {
    "method": "POST",
    "path": "/api/product/image-check-and-describe",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/product/detail": {
    "method": "POST",
    "path": "/api/product/detail",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/product/attribute": {
    "method": "GET",
    "path": "/api/product/attribute",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/product/attribute": {
    "method": "POST",
    "path": "/api/product/attribute",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/videos": {
    "method": "POST",
    "path": "/api/open/v1/videos",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/videos/preview": {
    "method": "POST",
    "path": "/api/open/v1/videos/preview",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/scripts": {
    "method": "POST",
    "path": "/api/open/v1/scripts",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/products/resolve": {
    "method": "POST",
    "path": "/api/open/v1/products/resolve",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/images": {
    "method": "POST",
    "path": "/api/open/v1/images",
    "bodyKind": "binary-json",
    "contentType": "application/json",
    "binaryFields": [
      "images"
    ],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/open/v1/images/import": {
    "method": "POST",
    "path": "/api/open/v1/images/import",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/oauth2/kalo": {
    "method": "POST",
    "path": "/api/oauth2/kalo",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/oauth2/google": {
    "method": "GET",
    "path": "/api/oauth2/google",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/oauth2/google": {
    "method": "POST",
    "path": "/api/oauth2/google",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/logout": {
    "method": "POST",
    "path": "/api/logout",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/login": {
    "method": "POST",
    "path": "/api/login",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "POST/api/log": {
    "method": "POST",
    "path": "/api/log",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/focus/product/queryListV2": {
    "method": "POST",
    "path": "/api/focus/product/queryListV2",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/focus/focusEntity": {
    "method": "POST",
    "path": "/api/focus/focusEntity",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/focus/cancelEntity": {
    "method": "POST",
    "path": "/api/focus/cancelEntity",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/download/video/script-generate": {
    "method": "POST",
    "path": "/api/download/video/script-generate",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/download/video/script-analysis": {
    "method": "POST",
    "path": "/api/download/video/script-analysis",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/devices/invalidate": {
    "method": "POST",
    "path": "/api/devices/invalidate",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/configurations": {
    "method": "POST",
    "path": "/api/configurations",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/captcha/verify": {
    "method": "POST",
    "path": "/api/captcha/verify",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/captcha/sms-send": {
    "method": "POST",
    "path": "/api/captcha/sms-send",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/captcha/email-send": {
    "method": "POST",
    "path": "/api/captcha/email-send",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/asset/record-download": {
    "method": "POST",
    "path": "/api/asset/record-download",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/user-link/refresh-token-once": {
    "method": "POST",
    "path": "/api/admin/user-link/refresh-token-once",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/trial-credit/compensate": {
    "method": "POST",
    "path": "/api/admin/trial-credit/compensate",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/test/slow-response": {
    "method": "POST",
    "path": "/api/admin/test/slow-response",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/rate-limit/clear": {
    "method": "POST",
    "path": "/api/admin/rate-limit/clear",
    "bodyKind": "json",
    "contentType": "application/json",
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/publish/poll-once": {
    "method": "POST",
    "path": "/api/admin/publish/poll-once",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/prompt/reload-all": {
    "method": "POST",
    "path": "/api/admin/prompt/reload-all",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "POST/api/admin/invalidate-tokens/{uid}": {
    "method": "POST",
    "path": "/api/admin/invalidate-tokens/{uid}",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [
      "uid"
    ],
    "hasQuery": false
  },
  "POST/api/admin/assets/trash-cleanup": {
    "method": "POST",
    "path": "/api/admin/assets/trash-cleanup",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/script-rewrite": {
    "method": "GET",
    "path": "/script-rewrite",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/image": {
    "method": "GET",
    "path": "/image",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/add-password": {
    "method": "GET",
    "path": "/add-password",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/login": {
    "method": "GET",
    "path": "/login",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/me": {
    "method": "GET",
    "path": "/me",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/privacy-policy": {
    "method": "GET",
    "path": "/privacy-policy",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/insight": {
    "method": "GET",
    "path": "/insight",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/authorization": {
    "method": "GET",
    "path": "/authorization",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/index": {
    "method": "GET",
    "path": "/index",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/video": {
    "method": "GET",
    "path": "/video",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/library": {
    "method": "GET",
    "path": "/library",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/script-review": {
    "method": "GET",
    "path": "/script-review",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/reset-password": {
    "method": "GET",
    "path": "/reset-password",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/tiktok-shop-auth-callback": {
    "method": "GET",
    "path": "/tiktok-shop-auth-callback",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/video-creating": {
    "method": "GET",
    "path": "/video-creating",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/signup": {
    "method": "GET",
    "path": "/signup",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/theme": {
    "method": "GET",
    "path": "/theme",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/social-publisher": {
    "method": "GET",
    "path": "/social-publisher",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/vi": {
    "method": "GET",
    "path": "/vi",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/ko": {
    "method": "GET",
    "path": "/ko",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/pt": {
    "method": "GET",
    "path": "/pt",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/th": {
    "method": "GET",
    "path": "/th",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/ja": {
    "method": "GET",
    "path": "/ja",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/id": {
    "method": "GET",
    "path": "/id",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/my": {
    "method": "GET",
    "path": "/my",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/es": {
    "method": "GET",
    "path": "/es",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/zh": {
    "method": "GET",
    "path": "/zh",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/": {
    "method": "GET",
    "path": "/",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/cli-login": {
    "method": "GET",
    "path": "/cli-login",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/video-url": {
    "method": "GET",
    "path": "/api/video/video-url",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/try-example": {
    "method": "GET",
    "path": "/api/video/try-example",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/video/remake/job-detail": {
    "method": "GET",
    "path": "/api/video/remake/job-detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/product-info": {
    "method": "GET",
    "path": "/api/video/product-info",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/download-url": {
    "method": "GET",
    "path": "/api/video/download-url",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/detail": {
    "method": "GET",
    "path": "/api/video/detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/creation/job-detail": {
    "method": "GET",
    "path": "/api/video/creation/job-detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/video/creation-option": {
    "method": "GET",
    "path": "/api/video/creation-option",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/publish/result": {
    "method": "GET",
    "path": "/api/users/publish/result",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/publish/page": {
    "method": "GET",
    "path": "/api/users/publish/page",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/link/publish-video-check": {
    "method": "GET",
    "path": "/api/users/link/publish-video-check",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/link/publish-tk-check": {
    "method": "GET",
    "path": "/api/users/link/publish-tk-check",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/users/link/accounts": {
    "method": "GET",
    "path": "/api/users/link/accounts",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/users/collection/queryDetail": {
    "method": "GET",
    "path": "/api/users/collection/queryDetail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/collection/products/detail": {
    "method": "GET",
    "path": "/api/users/collection/products/detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/collection/delete": {
    "method": "GET",
    "path": "/api/users/collection/delete",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/users/assets": {
    "method": "GET",
    "path": "/api/users/assets",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/user-assets": {
    "method": "GET",
    "path": "/api/user-assets",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/user-assets/trash": {
    "method": "GET",
    "path": "/api/user-assets/trash",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/user-assets/detail": {
    "method": "GET",
    "path": "/api/user-assets/detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/tiktok-shop/seller-auth-callback": {
    "method": "GET",
    "path": "/api/tiktok-shop/seller-auth-callback",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/tiktok-shop/creator-auth-url": {
    "method": "GET",
    "path": "/api/tiktok-shop/creator-auth-url",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/tiktok-shop/asset-product": {
    "method": "GET",
    "path": "/api/tiktok-shop/asset-product",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/tiktok-shop/account-products": {
    "method": "GET",
    "path": "/api/tiktok-shop/account-products",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/support/contacts": {
    "method": "GET",
    "path": "/api/support/contacts",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/report/refund-quota": {
    "method": "GET",
    "path": "/api/report/refund-quota",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/product/keyword-search": {
    "method": "GET",
    "path": "/api/product/keyword-search",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/pay/queryOrder": {
    "method": "GET",
    "path": "/api/pay/queryOrder",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/pay/goToPay": {
    "method": "GET",
    "path": "/api/pay/goToPay",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/out/tiktok-shop/auth/callback": {
    "method": "GET",
    "path": "/api/out/tiktok-shop/auth/callback",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/open/v1/videos/{jobId}": {
    "method": "GET",
    "path": "/api/open/v1/videos/{jobId}",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [
      "jobId"
    ],
    "hasQuery": false
  },
  "GET/api/open/v1/videos/queue": {
    "method": "GET",
    "path": "/api/open/v1/videos/queue",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/open/v1/videos/options": {
    "method": "GET",
    "path": "/api/open/v1/videos/options",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/open/v1/jobs/{jobId}": {
    "method": "GET",
    "path": "/api/open/v1/jobs/{jobId}",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [
      "jobId"
    ],
    "hasQuery": false
  },
  "GET/api/open/v1/images/options": {
    "method": "GET",
    "path": "/api/open/v1/images/options",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/open/v1/device-flow/poll": {
    "method": "GET",
    "path": "/api/open/v1/device-flow/poll",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/open/v1/credits": {
    "method": "GET",
    "path": "/api/open/v1/credits",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/i18nVersion": {
    "method": "GET",
    "path": "/api/i18nVersion",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/focus/products-collection": {
    "method": "GET",
    "path": "/api/focus/products-collection",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/exchange-rate/convert": {
    "method": "GET",
    "path": "/api/exchange-rate/convert",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/devices": {
    "method": "GET",
    "path": "/api/devices",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/credits/logs": {
    "method": "GET",
    "path": "/api/credits/logs",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/credits/check-consumed": {
    "method": "GET",
    "path": "/api/credits/check-consumed",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/credits/balance": {
    "method": "GET",
    "path": "/api/credits/balance",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  },
  "GET/api/character-assets/detail": {
    "method": "GET",
    "path": "/api/character-assets/detail",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/asset/state": {
    "method": "GET",
    "path": "/api/asset/state",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "GET/api/asset/downloaded": {
    "method": "GET",
    "path": "/api/asset/downloaded",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": true
  },
  "DELETE/api/users/trash/empty": {
    "method": "DELETE",
    "path": "/api/users/trash/empty",
    "bodyKind": "none",
    "contentType": null,
    "binaryFields": [],
    "pathParams": [],
    "hasQuery": false
  }
} as const;

export type RouteMeta = typeof routeMeta;
